// A signed-in support agent counts as "Online" to the storefront chat wherever they are on the site — not
// only with the inbox open: a heartbeat (customer-support {presence}) every half minute from any page,
// a tab in the background too. Someone who is not an agent is answered access_denied once, and asked no
// more. Mounted once by the site's layout.
import { useEffect } from "react"
import PlatformAuth from "aldoo-ra/PlatformAuth"
import { AgentPresence } from "./api"

const PRESENCE_MS = 30 * 1000

export default function AgentPresenceBeat() {
  const [auth] = PlatformAuth.useAuth()
  const token = auth?.auth_token
  useEffect(() => {
    if (!token) return
    let stopped = false
    let timer = null
    const beat = async () => {
      if (stopped) return
      const res = await AgentPresence().catch(() => null)
      // not an agent: nothing to tell
      if (res?.error === "access_denied" || res?.error === "invalid_request") {
        stopped = true
        clearInterval(timer)
      }
    }
    beat()
    timer = setInterval(beat, PRESENCE_MS)
    return () => {
      stopped = true
      clearInterval(timer)
    }
  }, [token])
  return null
}
